export default __webpack_public_path__ + "static/media/Ethereal.9155dc15.svg";